import Connector from './connector';
import { EntityDetailsProps } from './EntityDetails.proptype';
import { DetailedWithTabs } from '../DetailedWithTabs';

export * from './EntityDetails.proptype';

export const EntityDetails = (props: EntityDetailsProps) => <Connector {...props} component={DetailedWithTabs} />;
